import { useState } from "react"
import { toast } from 'react-hot-toast';
import ajaxChargeRate from "../../../util/remote/ajaxChargeRate";
import Loader from "../../Common/Loader";
import SystemModal from "../../Common/SystemModal";


const UpdateCommissionPercentage=(props)=>{

    const [loading, setLoading] = useState(false)
    const [rate, setRate] = useState(props.rate)

    const data = 
    {
        rate_id: props.rateID,
        rate: rate
    };

  const handleUpdate = async(e) =>
  {
    e.preventDefault()
    setLoading(true)
    const server_response = await ajaxChargeRate.updateCommissionPercentage(data);
    setLoading(false);
    if(server_response.status==="OK"){
      toast.success(server_response.message);
      props.g();
    }
    else{
      toast.error(server_response.message); 
    } 
  }
    
  const RenderFooter=(controls)=>{

    if(loading){
      return <Loader/>
    }else{

      return <> 
        <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
        <button 
          type="button" 
          className={`btn-fill-md text-light bg-dodger-blue`} 
          onClick={handleUpdate}>Save Changes<i class="fas fa-check mg-l-15"></i></button>
      </>
    }
  }

  return(
    <SystemModal
      title="Update Commission Percentage"
      id="model-update-dep-range"
      size="md"
      footer={RenderFooter}
    >

    

        <div className="row">
            <div className="col-xl-12 col-lg-12 col-12 form-group">
                <label htmlFor="">Commission Percentage</label>
                <input type="text" value={rate} onChange={(e)=>setRate(e.target.value)} className="form-control"/>
            </div>
  
        </div>
       
    </SystemModal>
    )
}

export default UpdateCommissionPercentage
